export const isNumberBetweenEquals = (number, min, max) => {
  return number >= min && number <= max;
};

export const getNumber = (value, defaultNumber = 0) => {
  const number = parseInt(value);
  return isNaN(number) ? defaultNumber : number;
};

/**
 * @description Returns "value" if is in boundaries of "min" and "max"
 * Returns "max" if "value" more than "max"
 * Returns "min" if "value" less than "min"
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export const clutch = (value, min, max) => {
  if (min > max) {
    max = min;
    min = max;
  }

  if (isNaN(value)) {
    return max;
  }

  if (value > max) {
    return max;
  } else if (value < min) {
    return min;
  }

  return value;
};

/**
 * @description Returns whether a given number is acceptable for calculations,
 * so if it's a regular digit number.
 * @param {number} value
 * @returns {boolean}
 */
export const isNumberCalculable = (value) => !isNaN(value) && typeof value === "number";

/**
 * @description Calculates direct or inverse proportion.
 * @param {number} value
 * @param {number} base
 * @param {number} baseNew
 * @returns {number}
 */
export const calcProportion = (value, base, baseNew) => {
  return value * baseNew / base;
};

export const calcPercentage = (partialValue, totalValue) => {
  return (100 * partialValue) / totalValue;
};

export const isDeltaEquals = (num1, num2, delta) => Math.abs(num1 - num2) <= delta;

export const int3DigitFormat = (n, separator = ",") => {
  const list = (Number.isInteger(n) ? n : n | 0).toString().split("");
  const l = list.length;
  for (let i = l - 3; i > 0; i -= 3) {
    list.splice(i, 0, separator);
  }
  return list.join("");
};

export const toFixedWithoutRounding = (num, fixed) => {
  if (typeof num !== "number" || isNaN(num)) {
    return 0;
  }

  const regExp = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
  return num.toString().match(regExp)[0];
}

export const roundNumberToDecimalWithStep = (num, decimalStep) => {
  if (typeof num === "number") {

    const [int, fraction] = num.toString().split(".");

    if (fraction && fraction[0]) {
      return parseFloat(int + "." + (fraction[0] - fraction[0] % decimalStep));
    }

  }

  return num;
};
